import React from 'react';
import PivotTableChart from './PivotTableChart';

// Sample test data
const sampleData = [
  { region: 'Norte', producto: 'A', ventas: 1000, fecha: '2024-01', categoria: 'Electronics' },
  { region: 'Sur', producto: 'B', ventas: 1500, fecha: '2024-01', categoria: 'Clothing' },
  { region: 'Norte', producto: 'A', ventas: 1200, fecha: '2024-02', categoria: 'Electronics' },
  { region: 'Sur', producto: 'B', ventas: 1800, fecha: '2024-02', categoria: 'Clothing' },
  { region: 'Este', producto: 'C', ventas: 2000, fecha: '2024-01', categoria: 'Food' },
  { region: 'Oeste', producto: 'D', ventas: 900, fecha: '2024-02', categoria: 'Electronics' },
];

const PivotTableChartExample = () => {
  return (
    <div>
      <h1>Ejemplo de PivotTableChart</h1>
      <PivotTableChart
        data={sampleData}
        title="Análisis de Ventas por Región y Producto"
        observaciones="Datos de ejemplo del primer trimestre 2024"
        storageKey="example-pivot-table"
      />
    </div>
  );
};

export default PivotTableChartExample;
